/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

//columns for main table 
export const columns: TableColumn[] = [
        {
          Header: "operatorManagement.tableColumns.slNo",
          accessor: "slno",
        },
        {
          Header: 'scheduleOperator.tableColumns.production_schedule',
          accessor: 'production_schedule_name',
        },
        {
          Header: 'scheduleOperator.tableColumns.product_name',
          accessor: 'product_name',
        },
        {
          Header: "tableCommon.batch_code",
          accessor: "batch_number",
        },
        {
          Header: "tableCommon.seriel_number",
          accessor: "serial_number",
        },
        {
          Header: "operatorManagement.tableColumns.autoClaveEndsIn",
          accessor: 'autoclaveEndTime',
        },
        {
          Header: "operatorManagement.tableColumns.activityType",
          accessor: "plate_type",
        },
         {
          Header: 'Area Name',
          accessor: 'area_name',
        },
        {
          Header: 'Location Name',
          accessor: 'location_name',
        },
        // {
        //   Header: "operatorManagement.tableColumns.plateStatus",
        //   accessor: "status",
        // },
        {
          Header: 'operatorManagement.tableColumns.autoClavedBy',
          accessor: 'autoclave_user',
        },
  ];

//columns for history table 
export const HistoryColumns: TableColumn[] = [
  {
    Header: "operatorManagement.tableColumns.slNo",
    accessor: "slno",
  },
  {
    Header: 'scheduleOperator.tableColumns.production_schedule',
    accessor: 'production_schedule_name',
  },
  {
    Header: 'scheduleOperator.tableColumns.product_name',
    accessor: 'product_name',
  },
  {
    Header: "tableCommon.batch_code",
    accessor: "batch_number",
  },
  {
    Header: "tableCommon.seriel_number",
    accessor: "serial_number",
  },
  {
    Header: 'operatorManagement.tableColumns.autoClaveDuration',
    accessor: 'autoclave_end_time',
  },
  {
    Header: "operatorManagement.tableColumns.activityType",
    accessor: "plate_type",
  },
  {
    Header: 'operatorManagement.tableColumns.autoClavedBy',
    accessor: 'autoclave_user',
  },

]

  
interface TableColumn {
    Header: string;
    accessor: string;
}